import {useCallback} from 'react'
import {useNavigation} from '@react-navigation/native'
import {StackActions} from '@react-navigation/native'

import {type NavigationProp} from '#/lib/routes/types'
import {router} from '#/routes'

/**
 * Hook for handling markdown link presses in support pages
 * Enables client-side navigation for internal links without page reloads
 */
export function useMarkdownLinkPress() {
  const navigation = useNavigation<NavigationProp>()

  const handleLinkPress = useCallback(
    (url: string) => {
      // Check if it's an internal link (starts with /)
      if (url.startsWith('/')) {
        try {
          // Use router to match the path and navigate
          const [screenName, params] = router.matchPath(url)
          navigation.dispatch(StackActions.push(screenName, params))
          return false // Prevent default behavior
        } catch (error) {
          console.warn('Failed to navigate to internal link:', url, error)
          return true // Fall back to default behavior on error
        }
      }
      // External link - allow default behavior (opens in browser)
      return true
    },
    [navigation],
  )

  return handleLinkPress
}
